let isPasteInProgress = false;

// Pasting an image uploads it, so a held or repeatedly pressed `Ctrl+V` would fire a
// `media-library-assets` request per keystroke. Pastes arriving while one is still being handled
// are dropped: they would upload the very same clipboard image into the very same element.

const runExclusivePaste = async (paste) => {
  if (isPasteInProgress) return;
  isPasteInProgress = true;

  try {
    await paste();
  } finally {
    isPasteInProgress = false;
  }
};

export default runExclusivePaste;
